import * as React from 'react';

import * as styles from './CommercialMultiAdsFactoids.css';

export interface ICommercialMultiAdsFactoidsProps {
  factoids?: string[] | null;
}

export const CommercialMultiAdsFactoids: React.FC<ICommercialMultiAdsFactoidsProps> = props => {
  const { factoids } = props;

  if (!factoids || !factoids.length) {
    return null;
  }

  return (
    <div className={styles['factoids-container']}>
      {factoids.map(factoid => (
        <li key={factoid} className={styles['factoid']}>
          {factoid}
        </li>
      ))}
    </div>
  );
};
